import DynamicForm from './Form'

export default DynamicForm
